import React from "react";
import Navbar from "../../components/Navbar";

function Home() {
  return (
    <>
      <Navbar />
     
      <div className="background-circle circle-3 z-0"></div>
      <div className="background-circle circle-4 z-0"></div>
      <main className="px-4 md:px-16 py-8">
        <div className="min-h-screen bg-transparent text-white p-4 md:p-14">
          <h1 className="text-yellow-500 ml-4 font-bold text-3xl">
            Welcome to the client Home Page, 
            Coming Soon...
          </h1>
        </div>
      </main>
    </>
  );
}

export default Home;
